/**
 * Blog Page
 */

export default function HWY_Blog() {
	const selectors = {
		category: ".category-filter",
		container: ".posts-container",
		loadMore: ".blog-landing .load-more button",
	};

	const pageSize = 8;

	const getUrlParam = (name) => {
		var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.search);
		return (results !== null) ? results[1] || 0 : false;
	}

	this.init = () => {

		if (window.location.pathname.includes("/blog/") && jQuery.urlParam("slug")) {
			const parts = window.location.search.split('=');
			const target = parts.pop() || parts.pop();
			const link = window.location.origin + "/blog/" + target;
			handleCategoryFilter(jQuery(`.category-filter[data-target*="${target}"]`));
			window.history.pushState(null, '', link);
		}
		else if (window.location.pathname.includes("/blog/") && window.location.pathname.length > 6) {
			const parts = window.location.pathname.split('/');
			const target = parts.pop() || parts.pop();
			window.location.href = window.location.origin + "/blog" + (target == "blog" ? "" : `?slug=${target}`);
		}


		jQuery(selectors.category).on("click", function () {
			handleCategoryFilter(jQuery(this))
		});

		jQuery(selectors.loadMore).on("click", function () {
			const category = jQuery(".category-filter.active").data("target");
			const hiddenPosts = (category == 'all') ? jQuery(this).closest(selectors.container).find(`.post.d-none`) : jQuery(this).closest(selectors.container).find(`.post.d-none[data-category*="${category}"`);
			hiddenPosts.each(function(index) {
				if (index < pageSize) {
					jQuery(this).removeClass("d-none");
				}
			})
			const current = jQuery(this).closest(selectors.container).find(".post:not(.d-none)").length;
			const total = (category == 'all') ? jQuery(this).closest(selectors.container).find(".post").length : jQuery(this).closest(selectors.container).find(`.post[data-category*="${category}"]`).length;
			jQuery(".counts .current").text(current);
			jQuery(".counts .total").text(total);

			if (current == total)
				jQuery(".load-more").addClass("d-none")
			else
				jQuery(".load-more").removeClass("d-none")
		})

		jQuery(".categories h4").on("click", function() {
			if (window.innerWidth > 768) return;

			if ( jQuery(this).hasClass("opened") ) {
				jQuery(this).next().hide();
			} else {
				jQuery(this).next().css({"display": "flex"});
			}

			jQuery(this).toggleClass("opened");
		})
	};

	const handleCategoryFilter = (element) => {
		const category = element.data("target");

		jQuery(`.post`).addClass("d-none");
		const posts = category == "all" ? jQuery(".post") : jQuery(`.post[data-category*="${category}"]`);

		posts.each(function(index) {
			if (index < pageSize) {
				jQuery(this).removeClass("d-none")
			}
		})

		element.closest(".category-filters").find(selectors.category).removeClass("active");
		element.addClass("active");

		const current = element.closest(selectors.container).find(".post:not(.d-none)").length;
		const total = posts.length;
		jQuery(".counts .current").text(current);
		jQuery(".counts .total").text(total);

		if (current == total)
			jQuery(".load-more").addClass("d-none")
		else
			jQuery(".load-more").removeClass("d-none")


		const link = window.location.origin + "/blog/" + (category == "all" ? "" : category);
		window.history.pushState(null, '', link);

		if (window.innerWidth < 769) {
			element.closest(".categories").find("h4").toggleClass("opened");
			element.closest(".categories").find(".category-filters").hide();
		}
	}
}
